<div class="h-100 w-100 d-flex flex-column">

  <div class="container">

    <div class="header rounded mt-4">

      <header class="text-center p-5">
        <div class="fs-2 text-uppercase">Join Our Community</div>
        <div class="fs-4">With us, you never need to apply. Education when you need it.</div>
      </header>

    </div>

    <div class="bg-light rounded mt-4 mb-5">

      <section class="page-section bg-light">

        @if (isLoading) {
          <div>
            <div class="text-center">
              <span class="fs-4">Retrieving Registration Information...</span>
              <div class="text-center mt-4">
                <span class="fa fa-spinner spinner-splash"></span>
              </div>
            </div>
          </div>
        }

        @if (!isLoading) {
          <div class="container"
            >
            <div class="text-center">
              <h2 class="section-heading">Multiple Platforms. Unlimited Opportunities.</h2>
              <hr class="text-site-primary mx-5" />
            </div>
            <div class="d-flex justify-content-center flex-wrap">
              @for (registrationSite of registrationProduct?.registrationSites; track registrationSite) {
                <div
                  class="registration-site border-1 bg-white p-3 m-3 flex-shrink-0 flex-grow-0 shadow text-center d-flex flex-column justify-content-between">
                  <div>
                    <img [src]="registrationSite.logoUri"
                      [ngStyle]="{'background-color': registrationSite.backgroundColor || defaultBackgroundColor}"
                      alt="{{registrationSite.logoAlt}}"
                      class="img-fluid p-3 rounded-1" />
                    </div>
                    <p class="text-start text-muted bg-white p-2 px-1">{{registrationSite.description}}</p>
                    <a href="{{registrationSite.uri}}" class="btn btn-lg btn-site-primary text-uppercase register-button align-self-center">
                      <span class="align-middle">Register</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-plus ps-1 align-middle" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                    </a>
                  </div>
                }
              </div>
            </div>
          }
        </section>

      </div>

    </div>

  </div>
